// extracted by mini-css-extract-plugin
export default {"table":"ListKitchen_table__q6GH+"};